<template>
  <v-flex
    id="food"
    class="question"
  >
    <p class="mb-0 text-uppercase">
      {{ $t('sheet.sheet_two.hint') }}
    </p>
    <h2 class="header mb-0">
      {{ getFoodQuestions.label }}
    </h2>
    <ul class="questions-list">
      <li
        v-if="getFoodQuestions.hasOwnProperty('chosen_products')"
        class="mt-4"
      >
        <v-layout wrap>
          <v-flex
            v-for="(item, index) in productsList"
            :key="index"
            lg3
            md6
            xs6
          >
            <v-checkbox
              v-model="chosenProducts"
              v-validate="{ required: getFoodQuestions.chosen_products.required }"
              multiple
              :label="item.description"
              :value="item.id"
              :disabled="readOnly"
              :data-vv-as="' '"
              data-vv-name="foodChosenProducts"
            />
          </v-flex>
        </v-layout>
      </li>
      <li
        v-if="
          showProductsForBabiesQuestion && getFoodQuestions.hasOwnProperty('products_for_babies')
        "
        class="mt-4"
      >
        <p
          class="header started lA mb-0"
          :class="{ required: getFoodQuestions.products_for_babies.required }"
        >
          {{ getFoodQuestions.products_for_babies.label }}
        </p>
        <v-textarea
          v-model="productsForBabies"
          v-validate="{ ...requiredRegularField(getFoodQuestions.products_for_babies.required) }"
          :placeholder="$t('placeholders.add_text')"
          :error-messages="errors.collect('food')"
          :data-vv-as="' '"
          data-vv-name="food"
          :required="getFoodQuestions.products_for_babies.required"
          :disabled="readOnly"
          auto-grow
          :rows="1"
        />
      </li>
      <li
        v-if="showOtherProductsQuestion && getFoodQuestions.hasOwnProperty('other_products')"
        class="mt-4"
      >
        <p
          class="header started lA mb-0"
          :class="{ required: getFoodQuestions.other_products.required }"
        >
          {{ getFoodQuestions.other_products.label }}
        </p>
        <v-textarea
          v-model="otherProducts"
          v-validate="{ ...requiredRegularField(getFoodQuestions.other_products.required) }"
          :placeholder="$t('placeholders.add_text')"
          :error-messages="errors.collect('food_1')"
          :data-vv-as="' '"
          data-vv-name="food_1"
          :required="getFoodQuestions.other_products.required"
          :disabled="readOnly"
          auto-grow
          :rows="1"
        />
      </li>
      <li
        v-if="getFoodQuestions.hasOwnProperty('has_dietary_requirements')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getFoodQuestions.has_dietary_requirements.required }"
        >
          {{ getFoodQuestions.has_dietary_requirements.label }}
        </p>
        <ConfirmButtons
          v-model="hasDietaryRequirements"
          v-validate="{ required: getFoodQuestions.has_dietary_requirements.required }"
          string
          :error-messages="errors.collect('hasDietaryRequirements')"
          :data-vv-as="' '"
          :data-vv-name="'hasDietaryRequirements'"
          :disabled="readOnly"
        />
      </li>
      <li
        v-if="
          hasDietaryRequirements === 'yes' &&
            getFoodQuestions.hasOwnProperty('dietary_requirements')
        "
        class="mt-4"
      >
        <p
          class="header custom lA mb-0"
          :class="{ required: getFoodQuestions.dietary_requirements.required }"
        >
          {{ getFoodQuestions.dietary_requirements.label }}
        </p>
        <v-textarea
          v-model="dietaryRequirements"
          v-validate="{ ...requiredRegularField(getFoodQuestions.dietary_requirements.required) }"
          :placeholder="$t('placeholders.add_text')"
          :error-messages="errors.collect('food_2')"
          :data-vv-as="' '"
          data-vv-name="food_2"
          :required="getFoodQuestions.dietary_requirements.required"
          :disabled="readOnly"
          :rows="1"
          auto-grow
        />
      </li>
    </ul>
    <v-divider class="my-4" />
  </v-flex>
</template>

<script>
import ConfirmButtons from '@/components/widgets/sheet/ConfirmButtons';

import validationRules from '@/constants/validationRules';
import { createHelpers } from 'vuex-map-fields';
import { mapGetters } from 'vuex';

import sheetResourcesGetter from '@/mixins/sheet/sheetResourcesGetter';
import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';

const { mapFields } = createHelpers({
    getterType: 'sheet/getFoodFields',
    mutationType: 'sheet/updateFoodField'
});

export default {
    name: 'SheetFood',
    components: { ConfirmButtons },
    mixins: [sheetResourcesGetter, sheetValidationRules],
    inject: ['$validator'],
    props: {
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            validationRules
        };
    },
    computed: {
        ...mapFields([
            'chosenProducts',
            'productsForBabies',
            'otherProducts',
            'hasDietaryRequirements',
            'dietaryRequirements'
        ]),
        productsList () {
            return this.getSheetTwoResources(this.getFoodQuestions.chosen_products);
        },
        showProductsForBabiesQuestion () {
            return this.chosenProducts.includes(205);
        },
        showOtherProductsQuestion () {
            return this.chosenProducts.includes(206);
        },
        ...mapGetters('sheet', ['getFoodQuestions'])
    },
    watch: {
        showProductsForBabiesQuestion (val) {
            if (val === false) {
                this.productsForBabies = null;
            }
        },
        showOtherProductsQuestion (val) {
            if (val === false) {
                this.otherProducts = null;
            }
        },
        hasDietaryRequirements (val) {
            if (val === 'no') {
                this.dietaryRequirements = null;
            }
        }
    }
};
</script>

<style scoped></style>
